class Dom {
  static addStyleSheet(url) {
    if(!document.getElementById(url)) {
      let link = document.createElement('link');
      link.id = url;
      link.rel = 'stylesheet';
      link.href = url;
      document.head.insertBefore(link, document.head.firstChild);
    }
  }

  static addScript(url, callback) {
    const script = document.createElement('script');
    script.src = url;
    script.onload = callback;
    document.head.appendChild(script);
  }
}

export default Dom;